<div class="emma-multi-switch-list" [@fadeInOut]>
    <div *ngIf="hasSelectAll && items.length > 1" class="select-all">
        <emma-switch
            name="{{ name }}__selectAll"
            [checked]="isAllSelected"
            (checkedChange)="onSelectAllChanged($event)"
            [label]="selectAllLabel"
            [readonly]="readonly"
            [disabled]="disabled"
        ></emma-switch>
    </div>
    <div *ngIf="!hasSelectAll || !isAllSelected" [@fadeInOut]>
        <div class="m--margin-top-15 m--margin-bottom-15 m-form__separator"></div>
        <div *ngFor="let item of items">
            <emma-switch
                name="{{ name }}__{{
                    item?.constructor.name === 'String' || item?.constructor.name === 'Number'
                        ? item
                        : item[valueKey]
                }}"
                [checked]="
                    value?.includes(
                        item?.constructor.name === 'String' || item?.constructor.name === 'Number'
                            ? item
                            : item[valueKey]
                    )
                "
                (checkedChange)="
                    onSwitchChanged(
                        $event,
                        item?.constructor.name === 'String' || item?.constructor.name === 'Number'
                            ? item
                            : item[valueKey]
                    )
                "
                [label]="
                    item?.constructor.name === 'String' || item?.constructor.name === 'Number'
                        ? item
                        : item[labelKey]
                "
                [readonly]="readonly"
                [disabled]="disabled"
            ></emma-switch>
        </div>
    </div>
</div>
